import type { NewsPost } from './types.js';

export const post: NewsPost = {
  slug: '2026-09-15-sarcon',
  title: 'Rescue Ally is going to SARCon!',
  date: '2026-09-15',
  hero: '/news/sarcon-2026.webp',
  share: '/news/sarcon-2026-share.jpg',
  heroAlt: 'Get in, we are supporting rescuers',
  description:
    'Rescue Ally is sponsoring the Colorado Search and Rescue Convention the weekend of September 26. 50% off with code SARCON2026, and 10% of every sale goes to the Colorado Search and Rescue Association.',
  markdown: `We’re proud to announce that Rescue Ally is sponsoring the Colorado Search and Rescue Convention the weekend of September 26!

**In honor of the event, we're offering a HUGE 50% discount. In addition, 10% of EVERY sale will be donated** to the [Colorado Search and Rescue Association](https://coloradosar.org/).

Use code \`SARCON2026\` at checkout!

Being part of such an incredible group is an honor, and we’re thrilled to meet with SAR teams and other sponsor organizations to show what we can do. If you are on a team and want to see where Rescue Ally is headed, [check out what we're planning](https://rescueally.org/teams) and come find us!

`
};
